import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Button, FormControl, FormControlLabel, Grid, IconButton, MenuItem, Select } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";
import { getCarrierHubSDWANStatusChart, getCarrierHubSDWANLatencyChart, getCarrierHubSDWANDataRatesChart, getCarrierHubSDWANUsageChart, getCarrierHubSDWANHubsChart, getCarrierHubAgentDropdownList, getCarrierHubWanDropdownList, getCarrierHubsDropdownList,getHubEvents, getHubEventFilters, getCarrierHubSDWANBaseRttChart, getCarrierHubSDWANCurrentRttChart, getCarrierHubSDWANPacketDropChart, getCarrierHubSDWANTunnelMigrationChart, getCarrierHubSDWANPacingRateChart, getCarrierHubSDWANBTLBWChart, getAgentsList, getCarrierHubSDWANBytesInFlightChart,
    getCarrierHubSDWANCongestionWindowChart, getCarrierHubSDWANDroppedDataGramsChart, getCarrierHubSDWANOneWayDelayOwdChart, getCarrierHubSDWANAckCountChart, getCarrierHubSDWANPacingLimitedChart, getCarrierHubSDWANSentDataGramsChart, getCarrierHubSDWANBlockCountChart } from '../../../actions/Users/authenticateHub';
import _ from "lodash";
import { checkLoggedInUserAuthorizedToViewPage, convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI, getMinutes, getTimezoneCity, readableBytesAsGB, readableBytesAsMB } from "../../../utils/util";
import MultipleSelectChip from "./MultipleSelectChip";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import moment from "moment";
import Chart from "../../../components/Charts";
import { GET_CARRIER_HUB_SDWAN_DATA_RATES, GET_CARRIER_HUB_SDWAN_LATENCY, GET_CARRIER_HUB_SDWAN_STATUS, GET_CARRIER_HUB_SDWAN_USAGE, GET_CARRIER_HUB_SDWAN_HUBS, GET_CARRIER_HUB_SDWAN_BASE_RTT, GET_CARRIER_HUB_SDWAN_CURRENT_RTT, GET_CARRIER_HUB_SDWAN_PACKET_DROP, GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION, GET_CARRIER_HUB_SDWAN_PACING_RATE, GET_CARRIER_HUB_SDWAN_BTLBW, GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT, GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW, GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS, GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD,
    GET_CARRIER_HUB_SDWAN_ACK_COUNT, GET_CARRIER_HUB_SDWAN_PACING_LIMITED, GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS, GET_CARRIER_HUB_SDWAN_BLOCK_COUNT
 } from "../../../actions/types";
import Download from '../../../asset/image/DownloadUsage.svg';
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../../utils/constants";
import { EventsFilterMenu } from "./HubEventsFiltersMenu";
import { EVENT_FILTERS } from "../../../constants/Constants";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
interface EventFilters {
    devices: string[];
    modules: string[];
    levels: string[];
    sources: string[];
    eventsCount?: number
}


const AgentSDWAN = (props) => {
    const { newSummaryStartDate, newSummaryEndDate, getCarrierHubSDWANStatusChart, getCarrierHubSDWANLatencyChart, getCarrierHubSDWANStatus, getCarrierHubSDWANLatency, userTimezone, getCarrierHubSDWANDataRatesChart, getCarrierHubSDWANUsageChart, getCarrierHubSDWANHubsChart, getCarrierHubSDWANDataRates, getCarrierHubAgentDropdownList, getCarrierHubWanDropdownList,
        getCarrierHubsDropdownList, getCarrierHubSDWANUsage, getCarrierHubSDWANHubs, wanDropdown, hubsDropdown, location, history, hubEventDetails, getHubEvents, authReducer, getHubEventFilters,hubEventFilters, getCarrierHubSDWANBaseRtt, getCarrierHubSDWANCurrentRtt, getCarrierHubSDWANBaseRttChart, getCarrierHubSDWANCurrentRttChart, getCarrierHubSDWANPacketDropChart, getCarrierHubSDWANPacketDrop,
        getCarrierHubSDWANTunnelMigrationChart, getCarrierHubSDWANTunnelMigration, getCarrierHubSDWANPacingRateChart, getCarrierHubSDWANPacingRate, getCarrierHubSDWANBTLBWChart, getCarrierHubSDWANBtlbw, getAgentsList, getCarrierHubSDWANBytesInFlightChart, getCarrierHubSDWANBytesInFlight, getCarrierHubSDWANCongestionWindowChart, getCarrierHubSDWANCongestionWindow, getCarrierHubSDWANDroppedDataGramsChart, getCarrierHubSDWANDroppedDataGrams,
        getCarrierHubSDWANOneWayDelayOwdChart, getCarrierHubSDWANOneWayDelayOwd, getCarrierHubSDWANAckCountChart, getCarrierHubSDWANAckCount, getCarrierHubSDWANPacingLimitedChart, getCarrierHubSDWANPacingLimited, getCarrierHubSDWANSentDataGramsChart, getCarrierHubSDWANSentDataGrams, getCarrierHubSDWANBlockCountChart, getCarrierHubSDWANBlockCount, selectedAgent
    } = props;

    let _q = getDecodeURI(location?.search);
    const dispatch = useDispatch();
    const getInterval = (minutes) => {
        if (minutes <= 60) {
            return "1 minute"
        } else if (minutes <= 1440 && minutes > 60) {
            return "3 minute"
        } else if (minutes > 1440 && minutes <= 10080) {
            return "20 minute"
        } else {
            return "12 hour";
        }
    }
    const [selectedBin, setSelectedBin] = useState(getInterval(Math.ceil(((new Date(newSummaryEndDate)).getTime() - (new Date(newSummaryStartDate)).getTime()) / 60e3)));
    const [chartOptions, setChartOptions] = useState<any>({});
    const [selectedAgents, setSelectedAgents] = useState<any>([]);
    const [selectedDevice, setSelectedDevice] = useState();
    const [wansList, setWansList] = useState<any>([]);
    const [selectedWans, setSelectedWans] = useState<any>([]);
    const betaFeatureService = SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["service"];
    const betaFeatureFunction = SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["function"];
    const authorizedBetaUser = checkLoggedInUserAuthorizedToViewPage(betaFeatureService, betaFeatureFunction);
    const metricsList = ['Status', 'Smoothed RTT *', 'Throughput', 'Usage', 
        'Min RTT *', 'RTT', 'Packet Drop', 'Tunnel Migration',
        'Pacing Rate *', 'BTLBW *', 'Bytes In Flight *', 'Congestion Window *', 'Dropped DataGrams *', 'One Way Delay OWD *', 'Ack Count *', 'Pacing Limited *', 'Sent DataGrams *', 'Block Count *'
    ];
    const [selectedMetrics, setSelectedMetrics] = useState<any>(['Usage']);
    const [prevSelectedMetrics, setPrevSelectedMetrics] = useState<string[]>([]);
    const [hubsList, setHubsList] = useState<any>([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [selectedHubIds, setSelectedHubIds] = useState<any>([]);
    const [hubsData, setHubsData] = useState<any>([]);
    const chartRef = useRef<any>(null);
    const hubsRef = useRef<any>(null);
    const [hoverStart, setHoverStart] = useState();
    const [progressBarOptions, setProgressBarOptions] = useState<any>({});
    const [digitCount, setDigitCount] = useState([2, 2, 2, 2]);
    const [hubLabelLength, setLabelLength] = useState(false);
    const [missingLabelLength, setMissingLabelLength] = useState(0);
    const [usageUnit, setUsageUnit] = useState('GB');
    const [selectedEventFilters, setSelectedEventFilters] = useState<any>();
    const [trackCount, setTrackCount] = useState<any>(0);
    const [eventFilters, setEventFilters] = useState<EventFilters>();
    const [prevSelectedWans, setPrevSelectedWans] = useState<string[]>([]);
    const [prevSelectedHubIds, setPrevSelectedHubIds] = useState<string[]>([]);

    const visibleMetrics = useMemo(() => {
        if (authorizedBetaUser) return metricsList;
        return metricsList.filter(metric => !metric.includes('*'));
    }, [authorizedBetaUser]);

    useEffect(() => {
        if(_.isEmpty(selectedAgent) && _.isEmpty(selectedAgent?.k4Id)) {
            clearChartState();
            setHubsList([]);
            setWansList([]);
        }
        if(!_.isEmpty(selectedAgent)) {
            const agent = selectedAgent;
            if(!_.isEmpty(agent)) {
                setSelectedAgents([agent?.['site_name']])
            }
        }
    }, [selectedAgent])

    useEffect(() => {
        if (selectedAgents?.[0] && !_.isEmpty(selectedDevice)) {
            getCarrierHubWanDropdownList(selectedAgents?.[0], selectedDevice, newSummaryStartDate, newSummaryEndDate);
        }
    }, [selectedDevice])

    useEffect(() => {
        if (selectedAgents?.[0]) {
            getCarrierHubsDropdownList(newSummaryStartDate, newSummaryEndDate, selectedAgents?.[0]);
            setSelectedWans([]);
        }
    }, [newSummaryStartDate, newSummaryEndDate, selectedAgents])

    useEffect(() => {
        if (!_.isEmpty(wanDropdown)) {
            const data = wanDropdown.hasOwnProperty('data') ? wanDropdown.data : [];
            if (_q.hasOwnProperty('interface_name') && _q.interface_name) {
                setSelectedWans([{wanId: _q.wanId, interface_name: _q.interface_name}])
            } else {
                setSelectedWans(data);
            }
            setWansList(data);
        }
    }, [wanDropdown])

    useEffect(() => {
        if (!_.isEmpty(hubsDropdown)) {
            const data = hubsDropdown.hasOwnProperty('data') ? hubsDropdown.data : [];
            setHubsList(data?.map(hub => hub['hub_name']));
            setSelectedHubs(data?.map(hub => hub['hub_name']));
            setSelectedHubIds(data?.map(hub => hub['location_id']));
            setSelectedDevice(data?.map(deviceId => deviceId['device_id']))
        }
    }, [hubsDropdown])

    interface HubData {
        dataTypes: string[];
        columns: string[];
        rows: Array<[string, number, string, number]>;
    }

    interface HubsResponse {
        [hubName: string]: HubData;
    }

    useEffect(() => {
        if (!_.isEmpty(getCarrierHubSDWANHubs)) {
            const rawData = getCarrierHubSDWANHubs.hasOwnProperty('data') ? getCarrierHubSDWANHubs.data : {};
            if (rawData) {
                const hubsList = selectedHubs;
                const allIntervals: { start: number, end: number }[] = [];

                const processedData = Object.entries(rawData as HubsResponse).map(([hubName, hubData]) => {
                    const rowsData = hubData.rows.map((row, index, array) => {
                        const nextRow = array[index + 1];
                        if (nextRow) {
                            const interval = { start: row[1] * 1000, end: nextRow[1] * 1000 };
                            allIntervals.push(interval); // Collect all intervals
                            return {
                                start: interval.start,
                                end: interval.end,
                                hub_name: row[2],
                                status: row[3]
                            };
                        }
                        return null;
                    }).filter(Boolean);

                    return { name: hubName, data: rowsData };
                });

                const uniqueIntervals = _.uniqWith(allIntervals, (a, b) => a.start === b.start && a.end === b.end);

                hubsList.forEach(hub => {
                    const hubData = processedData.find(data => data.name === hub);
                    // if (!hubData) {
                    //     const missingHubData = uniqueIntervals.map(interval => ({
                    //         start: interval.start,
                    //         end: interval.end,
                    //         hub_name: hub,
                    //         status: 0
                    //     }));

                    //     processedData.push({
                    //         name: hub,
                    //         data: missingHubData
                    //     });
                    // }
                });

                setHubsData(processedData);
            }
            dispatch({ type: GET_CARRIER_HUB_SDWAN_HUBS, payload: {} });
        }
    }, [getCarrierHubSDWANHubs]);

    const fetchChartData = (metric, startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId) => {
        switch (metric) {
            case 'Status':
                return getCarrierHubSDWANStatusChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Smoothed RTT *':
                return getCarrierHubSDWANLatencyChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Throughput':
                return getCarrierHubSDWANDataRatesChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Usage':
                return getCarrierHubSDWANUsageChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Min RTT *':
                return getCarrierHubSDWANBaseRttChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'RTT':
                return getCarrierHubSDWANCurrentRttChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Packet Drop':
                return getCarrierHubSDWANPacketDropChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Tunnel Migration':
                return getCarrierHubSDWANTunnelMigrationChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Pacing Rate *':
                return getCarrierHubSDWANPacingRateChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'BTLBW *':
                return getCarrierHubSDWANBTLBWChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Bytes In Flight *':
                return getCarrierHubSDWANBytesInFlightChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Congestion Window *':
                return getCarrierHubSDWANCongestionWindowChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Dropped DataGrams *':
                return getCarrierHubSDWANDroppedDataGramsChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'One Way Delay OWD *':
                return getCarrierHubSDWANOneWayDelayOwdChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Ack Count *':
                return getCarrierHubSDWANAckCountChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Pacing Limited *':
                return getCarrierHubSDWANPacingLimitedChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Sent DataGrams *':
                return getCarrierHubSDWANSentDataGramsChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            case 'Block Count *':
                return getCarrierHubSDWANBlockCountChart(startDate, endDate, agent, wans, bin, selectedHubIds, selectedDeviceId);
            default:
                console.warn(`Unknown metric: ${metric}`);
                return null;
        }
    };

    useEffect(() => {
        const _interval = getInterval(
            Math.ceil(((new Date(newSummaryEndDate)).getTime() - (new Date(newSummaryStartDate)).getTime()) / 60e3)
        );
        if(selectedEventFilters) {
            getHubEvents(newSummaryStartDate, newSummaryEndDate, selectedAgents[0], selectedWans, _interval, selectedHubIds, selectedDevice,selectedEventFilters)
        }
    },[selectedEventFilters])

    const clearChartState = () => {
        dispatch({ type: GET_CARRIER_HUB_SDWAN_STATUS, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_LATENCY, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_DATA_RATES, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_USAGE, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_BASE_RTT, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_CURRENT_RTT, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_PACKET_DROP, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_PACING_RATE, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_BTLBW, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_ACK_COUNT, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_PACING_LIMITED, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS, payload: {} });
        dispatch({ type: GET_CARRIER_HUB_SDWAN_BLOCK_COUNT, payload: {} });
    };

    useEffect(() => {
        const _interval = getInterval(
            Math.ceil(((new Date(newSummaryEndDate)).getTime() - (new Date(newSummaryStartDate)).getTime()) / 60e3)
        );
        setSelectedBin(_interval);
        if (!_.isEmpty(selectedWans) && !_.isEmpty(selectedHubIds)) {
            getCarrierHubSDWANHubsChart(newSummaryStartDate, newSummaryEndDate, selectedAgents[0], selectedWans, _interval, selectedHubIds, selectedDevice);
            // getHubEvents(newSummaryStartDate, newSummaryEndDate, selectedAgents[0], selectedWans, _interval, selectedHubIds, selectedDevice,selectedEventFilters)
            // getHubEventFilters(newSummaryStartDate, newSummaryEndDate, selectedAgents[0], selectedWans, _interval, selectedHubIds, selectedDevice)
        }

        if (_.isEmpty(selectedHubs)) {
            clearChartState();
            dispatch({ type: GET_CARRIER_HUB_SDWAN_HUBS, payload: {} });
            setHubsData([]);
            return;
        }
        if (_.isEmpty(selectedWans)) {
            clearChartState();
            dispatch({ type: GET_CARRIER_HUB_SDWAN_HUBS, payload: {} });
            setHubsData([]);
            return;
        }
        if (!_.isEmpty(selectedMetrics) && !_.isEmpty(selectedWans) && !_.isEmpty(selectedHubIds)) {
            const newlyAddedMetrics = selectedMetrics.filter(metric => !prevSelectedMetrics.includes(metric));
            const deselectedMetrics = prevSelectedMetrics.filter(metric => !selectedMetrics.includes(metric));
        
            // 👉 Always re-fetch all metrics if WANs or HubIds changed
            const hasWansChanged = !_.isEqual(selectedWans, prevSelectedWans);
            const hasHubsChanged = !_.isEqual(selectedHubIds, prevSelectedHubIds);
        
            if (newlyAddedMetrics.length > 0 || hasWansChanged || hasHubsChanged) {
                const metricsToFetch = newlyAddedMetrics.length > 0 ? newlyAddedMetrics : selectedMetrics;
        
                metricsToFetch.forEach((metric: any) => {
                    fetchChartData(
                        metric,
                        newSummaryStartDate,
                        newSummaryEndDate,
                        selectedAgents[0],
                        selectedWans,
                        _interval,
                        selectedHubIds,
                        selectedDevice
                    );
                });
            }
            deselectedMetrics.forEach((metric) => {
                const actionMap = {
                    Status: GET_CARRIER_HUB_SDWAN_STATUS,
                    'Smoothed RTT *': GET_CARRIER_HUB_SDWAN_LATENCY,
                    Throughput: GET_CARRIER_HUB_SDWAN_DATA_RATES,
                    Usage: GET_CARRIER_HUB_SDWAN_USAGE,
                    'Min RTT *': GET_CARRIER_HUB_SDWAN_BASE_RTT,
                    'RTT': GET_CARRIER_HUB_SDWAN_CURRENT_RTT,
                    'Packet Drop': GET_CARRIER_HUB_SDWAN_PACKET_DROP,
                    'Tunnel Migration': GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION,
                    'Pacing Rate *': GET_CARRIER_HUB_SDWAN_PACING_RATE,
                    'BTLBW *': GET_CARRIER_HUB_SDWAN_BTLBW,
                    'Bytes In Flight *': GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT,
                    'Congestion Window *': GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW,
                    'Dropped DataGrams *': GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS,
                    'One Way Delay OWD *': GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD,
                    'Ack Count *': GET_CARRIER_HUB_SDWAN_ACK_COUNT,
                    'Pacing Limited *': GET_CARRIER_HUB_SDWAN_PACING_LIMITED,
                    'Sent DataGrams *': GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS,
                    'Block Count *': GET_CARRIER_HUB_SDWAN_BLOCK_COUNT,
                };

                const actionType = actionMap[metric];
                if (actionType) {
                    dispatch({ type: actionType, payload: {} });
                } else {
                    console.warn(`Unknown metric: ${metric}`);
                }
            });

            setPrevSelectedMetrics([...selectedMetrics]);
        } else {
            console.warn('No metrics selected.');
            clearChartState();
        }
    }, [selectedWans, selectedMetrics, selectedHubIds]); 
    
    const handleBinChange = (e) => {
        const value = e.target.value;
        setSelectedBin(value);
        selectedMetrics.forEach((metric) => {
            fetchChartData(metric, newSummaryStartDate, newSummaryEndDate, selectedAgents?.[0], selectedWans, value, selectedHubIds, selectedDevice);
        });
        if (!_.isEmpty(selectedWans) && !_.isEmpty(selectedHubIds)) {
            getCarrierHubSDWANHubsChart(newSummaryStartDate, newSummaryEndDate, selectedAgents[0], selectedWans, value, selectedHubIds, selectedDevice);
        }
    };

    const assignColor = (() => {
        const colorMap = new Map();
        const colorPalette = ["#1f3ab4", "#2e9fde", "#629b3a", "#dddb48", "#921fb3", "#dd2ba4", "#a5393a", "#e29448", "#0f957d", "#57cfc8",
            "#7e86d6", "#e7bf9e", "#f5a8ff", "#0a74cf", "#28cc4a", "#04592c", "#828282", "#ffca90"
        ];
        let colorIndex = 0;

        return (key) => {
            if (!colorMap.has(key)) {
                colorMap.set(key, colorPalette[colorIndex % colorPalette.length]);
                colorIndex++;
            }
            return colorMap.get(key);
        };
    })();

    const processChartData = (data, type, markerType, valueUnit) => {
        return Object.keys(data?.series || {}).map((key) => ({
            name: `${type} - ${key}`,
            data: data?.series[key]?.map(point => {
                if (point.y === "null" || point.y === null || isNaN(point.y)) {
                    point.y = null;
                }
                return point;
            }),
            marker: { symbol: markerType },
            color: assignColor(`${type}-${key}`),
            valueUnit,
        }));
    };

    const processCombinedUsageData = (downloadData, uploadData, type, markerType) => {
        const downloadUsageSeries = Object.keys(downloadData.series)?.map((el) => downloadData.series[el])?.flat() ?? [];
        const uploadUsageSeries = Object.keys(uploadData.series)?.map((el) => uploadData.series[el])?.flat() ?? [];

        const combinedData = [...downloadUsageSeries, ...uploadUsageSeries];

        const gbThreshold = Math.pow(1000, 3);
        const isGBCrossed = combinedData?.some((item) => item.y > gbThreshold);

        const convertBytes = isGBCrossed ? readableBytesAsGB : readableBytesAsMB;
        setUsageUnit(isGBCrossed ? 'GB' : 'MB')

        const downloadSeriesKeys = Object.keys(downloadData.series);
        const processedDownloadData = downloadSeriesKeys.map((key) => {
            const seriesData = downloadData.series[key];
            return {
                name: `Download ${type} - ${key}`,
                data: seriesData.map((item) => ({
                    ...item,
                    y: Number(convertBytes(item.y, false)),
                })),
                marker: { symbol: markerType },
                color: assignColor(`${type}-download-${key}`),
                valueUnit: isGBCrossed ? 'GB' : 'MB',
            };
        });

        const uploadSeriesKeys = Object.keys(uploadData.series);
        const processedUploadData = uploadSeriesKeys.map((key) => {
            const seriesData = uploadData.series[key];
            return {
                name: `Upload ${type} - ${key}`,
                data: seriesData.map((item) => ({
                    ...item,
                    y: Number(convertBytes(item.y, false)),
                })),
                marker: { symbol: markerType },
                color: assignColor(`${type}-upload-${key}`),
                valueUnit: isGBCrossed ? 'GB' : 'MB',
            };
        });

        return [
            ...processedDownloadData,
            ...processedUploadData
        ];
    };

    const calculateYAxisTickDigits = () => {
        if (chartRef.current && chartRef.current.chart) {
            const chart = chartRef.current.chart;
            const yAxes = chart?.yAxis || [];
            const allDigitCounts:any = [];
    
            yAxes.forEach((yAxis) => {
                const tickPositions = yAxis?.tickPositions || [];
    
                if (!Array.isArray(tickPositions) || tickPositions.length === 0) {
                    allDigitCounts.push(0);
                    return;
                }
    
                let isDot = false;
                const tickDigits = tickPositions.map((tick) => {
                    const tickString = `${tick}`;
                    if (tickString.includes('.') || tickString.includes('-')) {
                        isDot = true;
                    }
                    return tickString.length;
                });
    
                const largestNumber = Math.max(...tickDigits);
    
                if (!isFinite(largestNumber) || largestNumber <= 0) {
                    allDigitCounts.push(0);
                    return;
                }
    
                let spaceCount = 0;
                if (isDot) {
                    spaceCount = ((largestNumber - 1) * 7.19) + 3.37;
                } else {
                    spaceCount = largestNumber * 7.19;
                }
    
                if (!isFinite(spaceCount)) {
                    spaceCount = 0;
                }
    
                allDigitCounts.push(spaceCount);
            });
    
            if (allDigitCounts.every((count) => typeof count === 'number' && !isNaN(count))) {
                setDigitCount(allDigitCounts);
            }
        }
    };
    useEffect(() => {
        calculateYAxisTickDigits();
    }, [chartOptions]);

    const chartAreaSelectionHandler = () => {
        return (event: any) => {
            let start: any = moment(new Date(Math.ceil(event.xAxis[0].min)));
            let end = moment(new Date(Math.floor(event.xAxis[0].max)));
            pinchAndResetChart(start, end, 'customDates');
            return false;
        }
    }

    const calculatedSpacingLeftSecondChart = () => {
        const safeDigitCount = Array.isArray(digitCount) ? digitCount : [];
        const safeMissingLabelLength = isFinite(missingLabelLength) ? Number(missingLabelLength) : 0;
    
        const baseValues = [33, 48, 63, 77];
        const defaultSpacing = 33;
    
        const metricsLength = selectedMetrics?.length || 0;
    
        const baseValue = baseValues[metricsLength - 1] || defaultSpacing;
    
        let digitSum = 0;
        for (let i = 0; i < metricsLength; i++) {
            const value = safeDigitCount[i];
            if (isFinite(value)) {
                digitSum += Number(value);
            }
        }
    
        return !_.isEmpty(hubsData)
            ? hubLabelLength
                ? baseValue + digitSum + safeMissingLabelLength
                : baseValue + digitSum
            : 120;
    };
    

    const defaultChartOptions = {
        time: {
            timezone: getTimezoneCity(userTimezone)
        },
        chart: {
            type: 'spline',
            height: '400px',
            zoomType: 'x',
            plotBorderWidth: 1,
            spacingLeft: selectedMetrics?.length == 1 ? 79 : selectedMetrics?.length == 2 ? 53 : selectedMetrics?.length == 3 ? 27 : selectedMetrics?.length == 4 ? 1 : 80,
            resetZoomButton: {
                theme: {
                    style: {
                        display: 'none'
                    }
                }
            },
            style: {
                fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif",
            },
            events: {
                selection: chartAreaSelectionHandler()
            }
        },
        title: {
            text: `Agent : ${selectedAgents[0]}`,
            align: 'left',
            floating: true,
            x: 12,
            y: 20,
            style: {
                fontWeight: '500',
                fontSize: '16px'
            }
        },
        lang: {
            noData: "No Data",
        },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#303030',
            },
        },
        credits: {
            enabled: false
        },
        legend: {
            layout: 'horizontal',
            align: 'right',
            verticalAlign: 'top',
            y: 40,
            margin: 28,
            itemStyle: {
                color: '#3F3F3F'
            }
        },
        plotOptions: {
            series: {
                turboThreshold: 1000000,
                stickyTracking: false,
                connectNulls: false,
                point: {
                    events: {
                        click: function (this: any) {
                            setHoverStart(this.x);
                        },
                    },
                },
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            },
            colorByPoint: true,
        },
        tooltip: {
            valueSuffix: '',
            headerFormat: '',
            pointFormat: '<span style="color: #7e8089">{series.name}</span> <br/> <b style="color: #fff">{point.hub_name} {series.valueUnit}</b><br/>',
            valueDecimals: 0,
            borderWidth: 1,
            useHTML: true,
            borderRadius: 15,
            backgroundColor: '#060606',
            formatter: function (this: any) {
                let decimals = 3;
                if (this && !_.isEmpty(this.series)) {
                    decimals = this.series.name.includes("Status") ? 0 : 3;
                }
                if (this && !_.isEmpty(this.series) && this.series.name.includes("Hub")) {
                    return `
                        <b style="color: #7e8089">${Highcharts.dateFormat('%A, %b %e, %H:%M:%S', this.x)}</b><br/>
                        <b style="color: #7e8089">${this.series.name}</b>: 
                        <b style="color: #fff">${this.y.toFixed(decimals)} ${this.series.options.valueUnit || ''}</b>`;
                }
                else if (this && !_.isEmpty(this.series) && this.series.name.includes("Event")) {
                    return `
                        <b style="color: #7e8089">${Highcharts.dateFormat('%A, %b %e, %H:%M:%S', this.x)}</b><br/>
                        <b style="color: #7e8089">${this.series.name}</b>: 
                        <b style="color: #fff">${this.point.description}</b>`;
                }
                 else if (this && !_.isEmpty(this.series)) {
                    return `
                        <b style="color: #7e8089">${Highcharts.dateFormat('%A, %b %e, %H:%M:%S', this.x)}</b><br/>
                        <b style="color: #7e8089">${this.series.name}</b>: 
                        <b style="color: #fff">${this.y.toFixed(decimals)} ${this.series.options.valueUnit || ''}</b>`;
                }
            }
        },
        xAxis: {
            gridLineWidth: 0.5,
            reversed: false,
            type: "datetime",
            min: moment(newSummaryStartDate).utc().toDate().valueOf(),
            max: moment(newSummaryEndDate).utc().toDate().valueOf(),
            maxPadding: 0.05,
            showLastLabel: true,
            labels: {
                style: {
                    color: '#2F4B82',
                    fontFamily: 'Inter',
                    fontSize: '9px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                }
            },
            plotBands: [{
                color: 'red',
                from: moment(hoverStart),
                to: moment(hoverStart),
            }],
        }
    }

    useEffect(() => {
        const allChartData: any = [];
        const yAxes: any = [];
        let eventSeries:any =[]
        let seriesData :any = []
        // !_.isEmpty(selectedEventFilters?.devices) && !_.isEmpty(selectedEventFilters?.modules) && !_.isEmpty(selectedEventFilters?.levels)
        if (!_.isEmpty(hubEventDetails?.data)) {
            seriesData = hubEventDetails?.data?.map(row => {

                const {ts, description ,device_id, deviceAlias, location_id, sitename, service, module, level, source, metadata} = row;
                return {
                    x: moment(ts).valueOf(),
                    y: 0,
                    // color: EVENT_FILTERS.LEVEL_COLOR[level] ? EVENT_FILTERS.LEVEL_COLOR[level] : 'black',
                    description: `Device ID: <b>${device_id}</b></br> Module: <b>${module}</b></br> Level: <b>${level}</b></br><b><i>${description}</i></b>`
                }
            });
            eventSeries = [{
                name: 'Event',
                data: seriesData,
                color: 'red',
                lineWidth: 0,
                marker: {
                    enabled: true,
                    symbol: 'square'
                },
                tooltip: {
                    useHTML: true,
                    formatter: function (this:any) {
                        console.log("formatter",this)
                        return this.point.description;
                    }
                }
            }]
        }

        selectedMetrics.forEach((option, index) => {
            let chartData: any = [];
            let unit = '';

            if (option === "Status" && !_.isEmpty(getCarrierHubSDWANStatus)) {
                unit = "";
                chartData = processChartData(getCarrierHubSDWANStatus?.data?.status, "Status", "circle", "");
            } else if (option === "Smoothed RTT *" && !_.isEmpty(getCarrierHubSDWANLatency)) {
                unit = "ms";
                chartData = processChartData(getCarrierHubSDWANLatency?.data?.latency, "Smoothed RTT", "circle", "ms");
            } else if (option === "Throughput" && !_.isEmpty(getCarrierHubSDWANDataRates)) {
                unit = "Mbps";
                chartData = [
                    ...processChartData(getCarrierHubSDWANDataRates?.data?.avgDownSpeed, "Download Rate", "circle", "mbps"),
                    ...processChartData(getCarrierHubSDWANDataRates?.data?.avgUpSpeed, "Upload Rate", "circle", "mbps"),
                ];
            } else if (option === "Usage" && !_.isEmpty(getCarrierHubSDWANUsage?.data?.download) && !_.isEmpty(getCarrierHubSDWANUsage?.data?.upload)) {
                const usageData = processCombinedUsageData(getCarrierHubSDWANUsage?.data?.download, getCarrierHubSDWANUsage?.data?.upload, 'Usage', 'circle');
                unit = usageData[0]?.valueUnit;
                chartData = usageData;
            } else if (option === "Min RTT *" && !_.isEmpty(getCarrierHubSDWANBaseRtt)) {
                unit = "ms";
                chartData = processChartData(getCarrierHubSDWANBaseRtt?.data?.latency, "Min RTT", "circle", "ms");
            } else if (option === "RTT" && !_.isEmpty(getCarrierHubSDWANCurrentRtt)) {
                unit = "ms";
                chartData = processChartData(getCarrierHubSDWANCurrentRtt?.data?.latency, "RTT", "circle", "ms");
            } else if (option === "Packet Drop" && !_.isEmpty(getCarrierHubSDWANPacketDrop?.data?.dl_packet_drops) && !_.isEmpty(getCarrierHubSDWANPacketDrop?.data?.ul_packet_drops)) {
                unit = "";
                chartData = [
                    ...processChartData(getCarrierHubSDWANPacketDrop?.data?.dl_packet_drops, "Download Packet Drop", "circle", ""),
                    ...processChartData(getCarrierHubSDWANPacketDrop?.data?.ul_packet_drops, "Upload Packet Drop", "circle", ""),
                ];
            } else if (option === "Tunnel Migration" && !_.isEmpty(getCarrierHubSDWANTunnelMigration)) {
                unit = "";
                chartData = processChartData(getCarrierHubSDWANTunnelMigration?.data?.Tunnel_Migration, "Tunnel Migration", "circle", "");
            } else if (option === "Pacing Rate *" && !_.isEmpty(getCarrierHubSDWANPacingRate?.data?.dl_pacing_rate) && !_.isEmpty(getCarrierHubSDWANPacingRate?.data?.ul_pacing_rate)) {
                unit = "mbps";
                chartData = [
                    ...processChartData(getCarrierHubSDWANPacingRate?.data?.dl_pacing_rate, "Download Pacing Rate", "circle", "mbps"),
                    ...processChartData(getCarrierHubSDWANPacingRate?.data?.ul_pacing_rate, "Upload Pacing Rate", "circle", "mbps"),
                ];
            } else if (option === "BTLBW *" && !_.isEmpty(getCarrierHubSDWANBtlbw?.data?.dl_btlbwe) && !_.isEmpty(getCarrierHubSDWANBtlbw?.data?.ul_btlbwe)) {
                unit = "mbps";
                chartData = [
                    ...processChartData(getCarrierHubSDWANBtlbw?.data?.dl_btlbwe, "Download BTLBW", "circle", "mbps"),
                    ...processChartData(getCarrierHubSDWANBtlbw?.data?.ul_btlbwe, "Upload BTLBW", "circle", "mbps"),
                ];
            } else if (option === "Bytes In Flight *" && !_.isEmpty(getCarrierHubSDWANBytesInFlight?.data?.dl_bytes_in_flight) && !_.isEmpty(getCarrierHubSDWANBytesInFlight?.data?.ul_bytes_in_flight)) {
                unit = "Bytes";
                chartData = [
                    ...processChartData(getCarrierHubSDWANBytesInFlight?.data?.dl_bytes_in_flight, "Download Bytes In Flight", "circle", "Bytes"),
                    ...processChartData(getCarrierHubSDWANBytesInFlight?.data?.ul_bytes_in_flight, "Upload Bytes In Flight", "circle", "Bytes"),
                ];
            } else if (option === "Congestion Window *" && !_.isEmpty(getCarrierHubSDWANCongestionWindow?.data?.dl_congestion_window) && !_.isEmpty(getCarrierHubSDWANCongestionWindow?.data?.ul_congestion_window)) {
                const usageData = processCombinedUsageData(getCarrierHubSDWANCongestionWindow?.data?.dl_congestion_window, getCarrierHubSDWANCongestionWindow?.data?.ul_congestion_window, 'Congestion Window', 'circle');
                unit = usageData[0]?.valueUnit;
                chartData = usageData;
            } else if (option === "Dropped DataGrams *" && !_.isEmpty(getCarrierHubSDWANDroppedDataGrams?.data?.dl_dropped_datagrams) && !_.isEmpty(getCarrierHubSDWANDroppedDataGrams?.data?.ul_dropped_datagrams)) {
                unit = "";
                chartData = [
                    ...processChartData(getCarrierHubSDWANDroppedDataGrams?.data?.dl_dropped_datagrams, "Download Dropped DataGrams", "circle", ""),
                    ...processChartData(getCarrierHubSDWANDroppedDataGrams?.data?.ul_dropped_datagrams, "Upload Dropped DataGrams", "circle", ""),
                ];
            } else if (option === "One Way Delay OWD *" && !_.isEmpty(getCarrierHubSDWANOneWayDelayOwd?.data?.dl_OWD) && !_.isEmpty(getCarrierHubSDWANOneWayDelayOwd?.data?.ul_OWD)) {
                unit = "ms";
                chartData = [
                    ...processChartData(getCarrierHubSDWANOneWayDelayOwd?.data?.dl_OWD, "Download One Way Delay OWD", "circle", "ms"),
                    ...processChartData(getCarrierHubSDWANOneWayDelayOwd?.data?.ul_OWD, "Upload One Way Delay OWD", "circle", "ms"),
                ];
            } else if (option === "Ack Count *" && !_.isEmpty(getCarrierHubSDWANPacingLimited?.data?.dl_pacing_limited) && !_.isEmpty(getCarrierHubSDWANPacingLimited?.data?.ul_pacing_limited)) {
                unit = "";
                chartData = [
                    ...processChartData(getCarrierHubSDWANPacingLimited?.data?.dl_pacing_limited, "Download Ack Count", "circle", ""),
                    ...processChartData(getCarrierHubSDWANPacingLimited?.data?.ul_pacing_limited, "Upload Ack Count", "circle", ""),
                ];
            } else if (option === "Sent DataGrams *" && !_.isEmpty(getCarrierHubSDWANSentDataGrams?.data?.dl_sent_datagrams) && !_.isEmpty(getCarrierHubSDWANSentDataGrams?.data?.ul_sent_datagrams)) {
                unit = "";
                chartData = [
                    ...processChartData(getCarrierHubSDWANSentDataGrams?.data?.dl_sent_datagrams, "Download Sent DataGrams", "circle", ""),
                    ...processChartData(getCarrierHubSDWANSentDataGrams?.data?.ul_sent_datagrams, "Upload Sent DataGrams", "circle", ""),
                ];
            } else if (option === "Block Count *" && !_.isEmpty(getCarrierHubSDWANBlockCount?.data?.dl_block_count) && !_.isEmpty(getCarrierHubSDWANBlockCount?.data?.ul_block_count)) {
                unit = "";
                chartData = [
                    ...processChartData(getCarrierHubSDWANBlockCount?.data?.dl_block_count, "Download Block Count", "circle", ""),
                    ...processChartData(getCarrierHubSDWANBlockCount?.data?.ul_block_count, "Upload Block Count", "circle", ""),
                ];
            }
            if (chartData.length) {
                chartData.forEach(data => data.yAxis = index);
                allChartData.push(...chartData);
            }
            yAxes.push({
                title: {
                    text: `${option}${unit ? ` (${unit})` : ""}`,
                    style: { color: '#787773' }
                },
                labels: {
                    style: {
                        color: '#787773',
                    },
                    opposite: true,
                },
                opposite: false,
            });
        });

        if (allChartData.length > 0 && yAxes.length > 0) {
            setChartOptions({
                ...defaultChartOptions,
                yAxis: yAxes,
                series: [...allChartData, ...eventSeries],
            });
        } else if(allChartData.length == 0) {
            setChartOptions({
                ...defaultChartOptions,
                chart: {
                    ...defaultChartOptions.chart,
                    spacingLeft: 120
                },
                yAxis: [],
                series: [],
            })
        }
    }, [getCarrierHubSDWANStatus, getCarrierHubSDWANLatency, getCarrierHubSDWANDataRates, getCarrierHubSDWANUsage, getCarrierHubSDWANBaseRtt, getCarrierHubSDWANCurrentRtt, getCarrierHubSDWANPacketDrop, getCarrierHubSDWANTunnelMigration, getCarrierHubSDWANPacingRate, getCarrierHubSDWANBtlbw, getCarrierHubSDWANBytesInFlight, getCarrierHubSDWANCongestionWindow,
        getCarrierHubSDWANDroppedDataGrams, getCarrierHubSDWANOneWayDelayOwd, getCarrierHubSDWANAckCount, getCarrierHubSDWANPacingLimited, getCarrierHubSDWANSentDataGrams, getCarrierHubSDWANBlockCount, hoverStart,hubEventDetails]);

    const pinchAndResetChart = (start, end, interval) => {
        let params = getDecodeURI(location?.search);
        params.startDate = start.valueOf();
        params.endDate = end.valueOf();
        params.interval = interval;
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const handleResetZoom = () => {
        const start = moment(Date.now()).subtract(1, 'hour');
        const end = moment(Date.now());
        pinchAndResetChart(start, end, '1h');
    }

    const handleHubSelection = (newValue) => {
        setSelectedHubs(newValue);
        const selectedIds = hubsDropdown?.data.filter(hub => newValue.includes(hub.hub_name)).map(hub => hub.location_id);
        const selectedDeviceids =  hubsDropdown?.data.filter(hub => newValue.includes(hub.hub_name)).map(hub => hub.device_id);
        setSelectedHubIds(selectedIds);
        setSelectedDevice(selectedDeviceids)
    }

    const handleWanSelection = (newValue) => {
        const wanInterface = wansList?.filter(wan => newValue.includes(wan.interface_name)).map(wan => wan);
        setSelectedWans(wanInterface);
    }

    const handleMetricSelection = (selected) => {
        setSelectedMetrics(selected)
    }

    const processCSVData = (hub: string, wanType: string, selectedMetrics: string[]) => {
        const data: any[] = [];
        const selectedWanType = `${hub} - ${wanType}`;

        const statusSeries = getCarrierHubSDWANStatus?.data?.status?.series[selectedWanType] || [];
        const latencySeries = getCarrierHubSDWANLatency?.data?.latency?.series[selectedWanType] || [];
        const avgDownSpeedSeries = getCarrierHubSDWANDataRates?.data?.avgDownSpeed?.series[selectedWanType] || [];
        const avgUpSpeedSeries = getCarrierHubSDWANDataRates?.data?.avgUpSpeed?.series[selectedWanType] || [];
        const downloadUsageSeries = getCarrierHubSDWANUsage?.data?.download?.series[selectedWanType] || [];
        const uploadUsageSeries = getCarrierHubSDWANUsage?.data?.upload?.series[selectedWanType] || [];
        const baseRttSeries = getCarrierHubSDWANBaseRtt?.data?.latency?.series[selectedWanType] || [];
        const currentRttSeries = getCarrierHubSDWANCurrentRtt?.data?.latency?.series[selectedWanType] || [];
        const downloadPacketDropSeries = getCarrierHubSDWANPacketDrop?.data?.dl_packet_drops?.series[selectedWanType] || [];
        const uploadPacketDropSeries = getCarrierHubSDWANPacketDrop?.data?.ul_packet_drops?.series[selectedWanType] || [];
        const tunnelMigrationSeries = getCarrierHubSDWANTunnelMigration?.data?.Tunnel_Migration?.series[selectedWanType] || [];
        const downloadPacingRateSeries = getCarrierHubSDWANPacingRate?.data?.dl_pacing_rate?.series[selectedWanType] || [];
        const uploadPacingRateSeries = getCarrierHubSDWANPacingRate?.data?.ul_pacing_rate?.series[selectedWanType] || [];
        const downloadBTLBWSeries = getCarrierHubSDWANBtlbw?.data?.dl_btlbwe?.series[selectedWanType] || [];
        const uploadBTLBWSeries = getCarrierHubSDWANBtlbw?.data?.ul_btlbwe?.series[selectedWanType] || [];
        const downloadBytesInFlightSeries = getCarrierHubSDWANBytesInFlight?.data?.dl_bytes_in_flight?.series[selectedWanType] || [];
        const uploadBytesInFlightSeries = getCarrierHubSDWANBytesInFlight?.data?.ul_bytes_in_flight?.series[selectedWanType] || [];
        const downloadCongestionWindowSeries = getCarrierHubSDWANCongestionWindow?.data?.dl_congestion_window?.series[selectedWanType] || [];
        const uploadCongestionWindowSeries = getCarrierHubSDWANCongestionWindow?.data?.ul_congestion_window?.series[selectedWanType] || [];
        const downloadDroppedDataGramsSeries = getCarrierHubSDWANDroppedDataGrams?.data?.dl_dropped_datagrams?.series[selectedWanType] || [];
        const uploadDroppedDataGramsSeries = getCarrierHubSDWANDroppedDataGrams?.data?.ul_dropped_datagrams?.series[selectedWanType] || [];
        const downloadOneWayDelayOwdSeries = getCarrierHubSDWANOneWayDelayOwd?.data?.dl_OWD?.series[selectedWanType] || [];
        const uploadOneWayDelayOwdSeries = getCarrierHubSDWANOneWayDelayOwd?.data?.ul_OWD?.series[selectedWanType] || [];
        const downloadAckCountSeries = getCarrierHubSDWANAckCount?.data?.DL_ACK_COUNT?.series[selectedWanType] || [];
        const uploadAckCountSeries = getCarrierHubSDWANAckCount?.data?.UL_ACK_COUNT?.series[selectedWanType] || [];
        const downloadPacingLimitedSeries = getCarrierHubSDWANPacingLimited?.data?.dl_pacing_limited?.series[selectedWanType] || [];
        const uploadPacingLimitedSeries = getCarrierHubSDWANPacingLimited?.data?.ul_pacing_limited?.series[selectedWanType] || [];
        const downloadSentDataGramsSeries = getCarrierHubSDWANSentDataGrams?.data?.dl_sent_datagrams?.series[selectedWanType] || [];
        const uploadSentDataGramsSeries = getCarrierHubSDWANSentDataGrams?.data?.ul_sent_datagrams?.series[selectedWanType] || [];
        const downloadBlockCountSeries = getCarrierHubSDWANSentDataGrams?.data?.dl_sent_datagrams?.series[selectedWanType] || [];
        const uploadBlockCountSeries = getCarrierHubSDWANSentDataGrams?.data?.ul_sent_datagrams?.series[selectedWanType] || [];

        const combinedData = [...downloadUsageSeries, ...uploadUsageSeries];

        const gbThreshold = 1000 * 1000 * 1000
        const isGBCrossed = combinedData?.some((item) => item.y > gbThreshold);

        const convertBytes = isGBCrossed ? readableBytesAsGB : readableBytesAsMB;

        const timestamps = Array.from(
            new Set([
                ...statusSeries.map(point => point.x),
                ...latencySeries.map(point => point.x),
                ...avgDownSpeedSeries.map(point => point.x),
                ...avgUpSpeedSeries.map(point => point.x),
                ...downloadUsageSeries.map(point => point.x),
                ...uploadUsageSeries.map(point => point.x),
                ...baseRttSeries.map(point => point.x),
                ...currentRttSeries.map(point => point.x),
                ...downloadPacketDropSeries.map(point => point.x),
                ...uploadPacketDropSeries.map(point => point.x),
                ...tunnelMigrationSeries.map(point => point.x),
                ...downloadPacingRateSeries.map(point => point.x),
                ...uploadPacingRateSeries.map(point => point.x),
                ...downloadBTLBWSeries.map(point => point.x),
                ...uploadBTLBWSeries.map(point => point.x),
                ...downloadBytesInFlightSeries.map(point => point.x),
                ...uploadBytesInFlightSeries.map(point => point.x),
                ...downloadCongestionWindowSeries.map(point => point.x),
                ...uploadCongestionWindowSeries.map(point => point.x),
                ...downloadDroppedDataGramsSeries.map(point => point.x),
                ...uploadDroppedDataGramsSeries.map(point => point.x),
                ...downloadOneWayDelayOwdSeries.map(point => point.x),
                ...uploadOneWayDelayOwdSeries.map(point => point.x),
                ...downloadAckCountSeries.map(point => point.x),
                ...uploadAckCountSeries.map(point => point.x),
                ...downloadPacingLimitedSeries.map(point => point.x),
                ...uploadPacingLimitedSeries.map(point => point.x),
                ...downloadSentDataGramsSeries.map(point => point.x),
                ...uploadSentDataGramsSeries.map(point => point.x),
                ...downloadBlockCountSeries.map(point => point.x),
                ...uploadBlockCountSeries.map(point => point.x),
            ])
        ).sort((a, b) => a - b);

        timestamps.forEach(timestamp => {
            const row: any[] = [
                hub,
                // `${hub_name}`,
                wanType,
                convertDateTimeIntoTimezone(
                    new Date(timestamp).toLocaleString(),
                    userTimezone,
                    MMDDYYYYHMMSS_DATE_FORMAT_24_HRS
                ).replace(',', ' '),
            ];

            selectedMetrics.forEach(metricKey => {
                switch (metricKey) {
                    case 'Status':
                        const statusData = statusSeries.find(point => point.x === timestamp);
                        row.push(statusData && statusData.y == 1 ? 'Online' : statusData && statusData.y == 0 ? 'Offline' : '');
                        break;
                    case 'Smoothed RTT *':
                        const latencyData = latencySeries.find(point => point.x === timestamp);
                        row.push(latencyData ? latencyData.y : '');
                        break;
                    case 'Throughput':
                        const avgDownSpeedData = avgDownSpeedSeries.find(point => point.x === timestamp);
                        const avgUpSpeedData = avgUpSpeedSeries.find(point => point.x === timestamp);
                        row.push(avgDownSpeedData ? avgDownSpeedData.y : '');
                        row.push(avgUpSpeedData ? avgUpSpeedData.y : '');
                        break;
                    case 'Usage':
                        const downloadData = downloadUsageSeries.find(point => point.x === timestamp);
                        const uploadData = uploadUsageSeries.find(point => point.x === timestamp);
                        row.push(downloadData ? convertBytes(downloadData.y, false) : '');
                        row.push(uploadData ? convertBytes(uploadData.y, false) : '');
                        break;
                    case 'Min RTT *':
                        const baseRttData = baseRttSeries.find(point => point.x === timestamp);
                        row.push(baseRttData ? baseRttData.y : '');
                        break;
                    case 'RTT':
                        const currentRttData = currentRttSeries.find(point => point.x === timestamp);
                        row.push(currentRttData ? currentRttData.y : '');
                        break;
                    case 'Packet Drop':
                        const downloadPacketDropData = downloadPacketDropSeries.find(point => point.x === timestamp);
                        const uploadUploadDropData = uploadPacketDropSeries.find(point => point.x === timestamp);
                        row.push(downloadPacketDropData ? downloadPacketDropData.y : '');
                        row.push(uploadUploadDropData ? uploadUploadDropData.y : '');
                        break;
                    case 'Tunnel Migration':
                        const tunnelMigrationData = tunnelMigrationSeries.find(point => point.x === timestamp);
                        row.push(tunnelMigrationData ? tunnelMigrationData.y : '');
                        break;
                    case 'Pacing Rate *':
                        const downloadPacingRateData = downloadPacingRateSeries.find(point => point.x === timestamp);
                        const uploadPacingRateData = uploadPacingRateSeries.find(point => point.x === timestamp);
                        row.push(downloadPacingRateData ? downloadPacingRateData.y : '');
                        row.push(uploadPacingRateData ? uploadPacingRateData.y : '');
                        break;
                    case 'BTLBW *':
                        const downloadBTLBWData = downloadBTLBWSeries.find(point => point.x === timestamp);
                        const uploadBTLBWData = uploadBTLBWSeries.find(point => point.x === timestamp);
                        row.push(downloadBTLBWData ? downloadBTLBWData.y : '');
                        row.push(uploadBTLBWData ? uploadBTLBWData.y : '');
                        break;
                    case 'Bytes In Flight *':
                        const downloadBytesInFlightData = downloadBytesInFlightSeries.find(point => point.x === timestamp);
                        const uploadBytesInFlightData = uploadBytesInFlightSeries.find(point => point.x === timestamp);
                        row.push(downloadBytesInFlightData ? downloadBytesInFlightData.y : '');
                        row.push(uploadBytesInFlightData ? uploadBytesInFlightData.y : '');
                        break;
                    case 'Congestion Window *':
                        const downloadCongestionWindowData = downloadCongestionWindowSeries.find(point => point.x === timestamp);
                        const uploadCongestionWindowData = uploadCongestionWindowSeries.find(point => point.x === timestamp);
                        row.push(downloadCongestionWindowData ? downloadCongestionWindowData.y : '');
                        row.push(uploadCongestionWindowData ? uploadCongestionWindowData.y : '');
                        break;
                    case 'Dropped DataGrams *':
                        const downloadDroppedDataGramsData = downloadDroppedDataGramsSeries.find(point => point.x === timestamp);
                        const uploadDroppedDataGramsData = uploadDroppedDataGramsSeries.find(point => point.x === timestamp);
                        row.push(downloadDroppedDataGramsData ? downloadDroppedDataGramsData.y : '');
                        row.push(uploadDroppedDataGramsData ? uploadDroppedDataGramsData.y : '');
                        break;
                    case 'One Way Delay OWD *':
                        const downloadOneWayDelayOwdData = downloadOneWayDelayOwdSeries.find(point => point.x === timestamp);
                        const uploadOneWayDelayOwdData = uploadOneWayDelayOwdSeries.find(point => point.x === timestamp);
                        row.push(downloadOneWayDelayOwdData ? downloadOneWayDelayOwdData.y : '');
                        row.push(uploadOneWayDelayOwdData ? uploadOneWayDelayOwdData.y : '');
                        break;
                    case 'Ack Count *':
                        const downloadAckCountData = downloadAckCountSeries.find(point => point.x === timestamp);
                        const uploadAckCountData = uploadAckCountSeries.find(point => point.x === timestamp);
                        row.push(downloadAckCountData ? downloadAckCountData.y : '');
                        row.push(uploadAckCountData ? uploadAckCountData.y : '');
                        break;
                    case 'Pacing Limited *':
                        const downloadPacingLimitedData = downloadPacingLimitedSeries.find(point => point.x === timestamp);
                        const uploadPacingLimitedData = uploadPacingLimitedSeries.find(point => point.x === timestamp);
                        row.push(downloadPacingLimitedData ? downloadPacingLimitedData.y : '');
                        row.push(uploadPacingLimitedData ? uploadPacingLimitedData.y : '');
                        break;
                    case 'Sent DataGrams *':
                        const downloadSentDataGramsData = downloadSentDataGramsSeries.find(point => point.x === timestamp);
                        const uploadSentDataGramsData = uploadSentDataGramsSeries.find(point => point.x === timestamp);
                        row.push(downloadSentDataGramsData ? downloadSentDataGramsData.y : '');
                        row.push(uploadSentDataGramsData ? uploadSentDataGramsData.y : '');
                        break;
                    case 'Block Count *':
                        const downloadBlockCountData = downloadBlockCountSeries.find(point => point.x === timestamp);
                        const uploadBlockCountData = uploadBlockCountSeries.find(point => point.x === timestamp);
                        row.push(downloadBlockCountData ? downloadBlockCountData.y : '');
                        row.push(uploadBlockCountData ? uploadBlockCountData.y : '');
                        break;
                    default:
                        break;
                }
            });

            data.push(row);
        });

        return data;
    };

    const generateCSVData = () => {
        const availableMetrics: any = [
            { key: 'Status', label: 'Status' },
            { key: 'Smoothed RTT *', label: 'Smoothed RTT (ms)' },
            {
                key: 'Throughput',
                subKeys: ['avgDownSpeed', 'avgUpSpeed'],
                subLabels: ['Download Rate (Mbps)', 'Upload Rate (Mbps)'],
            },
            {
                key: 'Usage',
                subKeys: ['downUsage', 'upUsage'],
                subLabels: [`Download Usage (${usageUnit})`, `Upload Usage (${usageUnit})`],
            },
            { key: 'Min RTT *', label: 'Min RTT (ms)' },
            { key: 'RTT', label: 'RTT (ms)' },
            {
                key: 'Packet Drop',
                subKeys: ['dl_packet_drops', 'ul_packet_drops'],
                subLabels: [`Download Packet Drop`, `Upload Packet Drop`],
            },
            { key: 'Tunnel Migration', label: 'Tunnel Migration' },
            {
                key: 'Pacing Rate *',
                subKeys: ['dl_pacing_rate', 'ul_pacing_rate'],
                subLabels: [`Download Pacing Rate (mbps)`, `Upload Pacing Rate (mbps)`],
            },
            {
                key: 'BTLBW *',
                subKeys: ['dl_btlbwe', 'ul_btlbwe'],
                subLabels: [`Download BTLBW (mbps)`, `Upload BTLBW (mbps)`],
            },
            {
                key: 'Bytes In Flight *',
                subKeys: ['dl_bytes_in_flight', 'ul_bytes_in_flight'],
                subLabels: [`Download Bytes In Flight (Bytes)`, `Upload Bytes In Flight (Bytes)`],
            },
            {
                key: 'Congestion Window *',
                subKeys: ['dl_congestion_window', 'ul_congestion_window'],
                subLabels: [`Download Congestion Window`, `Upload Congestion Window`],
            },
            {
                key: 'Dropped DataGrams *',
                subKeys: ['dl_dropped_datagrams', 'ul_dropped_datagrams'],
                subLabels: [`Download Dropped DataGrams`, `Upload Dropped DataGrams`],
            },
            {
                key: 'One Way Delay OWD *',
                subKeys: ['dl_OWD', 'ul_OWD'],
                subLabels: [`Download One Way Delay OWD (ms)`, `Upload One Way Delay OWD (ms)`],
            },
            {
                key: 'Ack Count *',
                subKeys: ['DL_ACK_COUNT', 'UL_ACK_COUNT'],
                subLabels: [`Download Ack Count`, `Upload Ack Count`],
            },
            {
                key: 'Pacing Limited *',
                subKeys: ['dl_pacing_limited', 'ul_pacing_limited'],
                subLabels: [`Download Pacing Limited`, `Upload Pacing Limited`],
            },
            {
                key: 'Sent DataGrams *',
                subKeys: ['dl_sent_datagrams', 'ul_sent_datagrams'],
                subLabels: [`Download Sent DataGrams`, `Upload Sent DataGrams`],
            },
            {
                key: 'Block Count *',
                subKeys: ['dl_block_count', 'ul_block_count'],
                subLabels: [`Download Block Count`, `Upload Block Count`],
            },
        ];

        const headers = [
            'Agent',
            // 'Hub',
            'WAN Name',
            `Time (${userTimezone})`,
            ...selectedMetrics.flatMap(metricKey => {
                const metric = availableMetrics.find(m => m.key === metricKey);
                return metric?.subLabels || [metric?.label];
            }),
        ];

        const csvData = [headers];

        selectedWans.forEach(wanType => {
            selectedHubs.forEach(hub => {
                const processedData = processCSVData(hub, wanType?.['wanId'], selectedMetrics);
                processedData.forEach(row => {
                    csvData.push(row);
                });
            });
        });

        return csvData;
    };

    const convertToCSV = (data) => {
        return data.map(row => row.join(',')).join('\n');
    };

    const downloadCSV = (csvData, fileName = 'agent_wan_report.csv') => {
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleDownloadMetricsReport = () => {
        const processedData = generateCSVData();
        const csvData = convertToCSV(processedData);
        downloadCSV(csvData, 'metrics_report.csv');
    };

    const handleDownloadReport = () => {
        !_.isEmpty(chartOptions?.series) && handleDownloadMetricsReport();
        !_.isEmpty(hubsData) && handleDownloadHubsReport();
    };

    const processHubsData = (hubsData) => {
        const headers = ['Hub Name', `Time (${userTimezone})`, 'Status'];
    
        const data = [headers];
    
        hubsData.forEach(hub => {
            hub.data.forEach(entry => {
                data.push([
                    hub.name,
                    convertDateTimeIntoTimezone(
                        new Date(entry.start).toISOString(),
                        userTimezone,
                        MMDDYYYYHMMSS_DATE_FORMAT_24_HRS
                    ).replace(',', ';'),
                    entry.status === 1 ? 'Connected' : 'Disconnected'
                ]);
            });
        });
    
        return data;
    };
    
    const generateHubsCSV = () => {
        const processedData = processHubsData(hubsData);
        return convertToCSV(processedData);
    };
    
    const handleDownloadHubsReport = () => {
        const csvData = generateHubsCSV();
        downloadCSV(csvData, 'hubs_report.csv');
    };

    const colors = ['#1d1462', '#1a3dae', '#368cd6', '#59b5ea', '#88caea', '#97cafd', '#69b8e5', '#3f79ca', '#9e8cc5', '#ed9340',
        '#8cafdf', '#d9914f', '#86c6df', '#3c7df1', '#61cdc0', '#64a1f4', '#dc6161', '#146680', '#2039b5', '#00ad64',
        '#1b4dac', '#b50000', '#8cb5ec', '#c1d5f6', '#b3bbe6', '#e5a8a8', '#f9dabe', '#4b91f1', '#8dbdff', '#efeab9',
        '#8a39a7', '#d9cb4f', '#145f89', '#e7d696', '#8592e7', '#e78585', '#92d7c9', '#aeaeb1', '#755c5d', '#7c6ce6',
        '#cc7460', '#bd9331', '#15e1e8', '#514ced', '#8633de', '#eb52b3', '#c4355b', '#6dc779', '#5373a3', '#8dc293'
    ]

    useEffect(() => {
        if (Array.isArray(selectedHubs) && selectedHubs.length > 0) {
            const hubListTicks = selectedHubs.map((hub) => {
                const hubString = `${hub}`;
                return hubString.length;
            });
    
            const hubLengthLabel = Math.max(...hubListTicks);
    
            if (hubLengthLabel >= 0 && hubLengthLabel < 10) {
                setLabelLength(true);
                const hubLabelDiffLength = 9 - hubLengthLabel;
    
                if (hubLabelDiffLength > 0) {
                    const missingDiffLength = (hubLabelDiffLength * 7.19) + 6.74;
    
                    if (isFinite(missingDiffLength)) {
                        setMissingLabelLength(missingDiffLength);
                    } else {
                        setMissingLabelLength(0);
                    }
                }
            } else {
                setLabelLength(false);
            }
        } else {
            setLabelLength(false);
            setMissingLabelLength(0);
        }
    }, [selectedHubs])

    useEffect(() => {
        setProgressBarOptions({
            time: {
                timezone: getTimezoneCity(userTimezone)
            },
            chart: {
                type: 'xrange',
                height: hubsData.length > 1 ? `${hubsData.length * 50}px` : "70px",
                spacingLeft: calculatedSpacingLeftSecondChart(),
                marginTop: 0,
                marginBottom: 20,

                plotBorderWidth: 1,

                style: {
                    fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif",
                },
                events: {
                    render: function (this: any) {
                        const chart = this;
                        if (chart.customSeriesLabels) {
                            chart.customSeriesLabels.forEach(label => label.destroy());
                        }
                        chart.customSeriesLabels = [];
    
                        chart.series.forEach((series, index) => {
                            if (series.name && series.points.length) {
                                const yPosition = series.points[0].plotY + chart.plotTop - 10;
                                const xPosition = chart.plotLeft + 10;
    
                                const label = chart.renderer
                                    .text(series.name, xPosition, yPosition)
                                    .css({
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        color: "#000",
                                    })
                                    .add();
    
                                chart.customSeriesLabels.push(label);
                            }
                        });
                    }
                }
            },
            title: {
                text: null,
            },
            lang: {
                noData: "No Data",
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '15px',
                    color: '#303030',
                },
            },
            xAxis: {
                gridLineWidth: 0.5,
                reversed: false,
                type: "datetime",
                min: moment(newSummaryStartDate).utc().toDate().valueOf(),
                max: moment(newSummaryEndDate).utc().toDate().valueOf(),
                maxPadding: 0.05,
                showLastLabel: true,
                visible: true,
                plotBands: [{
                    color: 'red',
                    from: moment(hoverStart),
                    to: moment(hoverStart),
                    zIndex: 100000000
                }],
            },
            yAxis: {
                categories: hubsData.map((hub) => hub.name),
                labels: {
                    style: {
                        width: '77',
                        minWidth: '77px',
                        maxWidth: '77px',
                        color: '#ffffff',
                        textOverflow: 'ellipsis'
                    }
                },
                title: null,
                visible: true
            },
            series: hubsData.map((hub, index) => ({
                name: hub.name,
                borderColor: 'transparent',
                borderWidth: 0,
                pointPadding: 0,
                groupPadding: 0.5,
                pointWidth: 15,
                data: hub.data.map(entry => ({
                    x: entry.start,
                    x2: entry.end,
                    y: index,
                    color: entry.status === 0 ? '#fff' : colors[index % colors.length],
                    statusLabel: entry.status.label,
                    points: entry.status.points,
                    status: entry.status
                })),
                dataLabels: { enabled: false },
            })),
            // series: !_.isEmpty(hubsData) ? [{
            //     name: 'Connection Status',
            //     borderColor: 'transparent',
            //     borderWidth: 0,
            //     pointPadding: 0,
            //     groupPadding: 0,
            //     pointWidth: 4,
            //     color: colors,
            //     data: hubsData.flatMap((hub, index) =>
            //         hub.data.map(entry => {
            //             const color = entry.status === 0 ? '#fff' : colors[index % colors.length];
            //             return {
            //                 x: entry.start,
            //                 x2: entry.end,
            //                 y: index,
            //                 color: color,
            //                 status: entry.status
            //             };
            //         })
            //     ),
            //     dataLabels: {
            //         enabled: false,
            //     },
            // }] : [],
            tooltip: {
                borderRadius: 15,
                backgroundColor: '#060606',
                formatter: function (this: any) {
                    if (this.point.status === 0) {
                        return false;
                    }
                    const hubName = this.series.chart.yAxis[0].categories[this.point.y];
                    return `
                        <b style="color: #7e8089">${Highcharts.dateFormat('%A, %b %e, %H:%M:%S', this.point.x)}</b><br/>
                        <b style="color: #7e8089">Hub: </b><b style="color: #fff">${hubName}</b><br/>
                        <b style="color: #7e8089">Status: </b><b style="color: #fff">${this.point.status == 1 ? 'Connected' : 'DIsconnected'}</b>`;
                },
                useHTML: true
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    borderRadius: 0,
                    pointWidth: 4,
                    groupPadding: 0,
                    pointPadding: 0,
                    borderWidth: 0,
                    borderColor: 'transparent',
                    point: {
                        events: {
                            click: function (this: any) {
                                setHoverStart(this.x);
                            },
                        },
                    },
                },
            },
        })
    }, [hubsData, hoverStart, digitCount, hubLabelLength])

    useEffect(() => {
        if (_.isEmpty(selectedEventFilters?.devices) || _.isEmpty(selectedEventFilters?.modules) || _.isEmpty(selectedEventFilters?.levels)) {
            // clearSiteChartEvents()
            // clearEdgeEvents()
        } else if(trackCount == 1) {
            // fetchChartData([], [], selectedEventFilters, selectedBin);
        }
        setTrackCount(trackCount + 1);
    }, [selectedEventFilters])

    useEffect(() => {
        if (!_.isEmpty(hubEventFilters?.data)) {
            const { data: response } = hubEventFilters;
            if (!_.isEmpty(response) && response.hasOwnProperty('filters')) {
                let filters: string[] | undefined = response?.filters?.data;
                if (filters?.length && filters.length >= 3) {
                    const [devices, modules, levels, sources, eventCount] = filters;
                    let _eventFilter: EventFilters = {
                        devices: devices?.split(','),
                        modules: modules?.split(','),
                        levels: levels?.split(','),
                        sources: sources?.split(','),
                        eventsCount: parseInt(eventCount)
                    };
                    setEventFilters(_eventFilter)

                    let _selectedEventFilters = {
                        devices: _eventFilter.devices.map(d => _eventFilter.devices[d] || d),
                        modules: _eventFilter.modules.filter(m => m !== EVENT_FILTERS._MODULES["WAN Management"]).map(m => EVENT_FILTERS.MODULES[m] || m),
                        levels: _eventFilter.levels.filter(l => l === EVENT_FILTERS._LEVELS["Critical"] || l === EVENT_FILTERS._LEVELS["Warning"]).map(l => EVENT_FILTERS.LEVELS[l] || l),
                        sources: _eventFilter.sources.map(s => EVENT_FILTERS.SOURCES[s] || s)
                    };
                    setSelectedEventFilters(_selectedEventFilters);        
                } else {
                    setSelectedEventFilters(undefined)
                    setEventFilters(undefined)
                }
            }
        }
    }, [hubEventFilters])

    const handleEventFiltersChange = (_devices, _modules, _levels, _sources) => {
        setTrackCount(1);
        if (selectedEventFilters) {
            let _eventFilters = { ...selectedEventFilters }
            let updated = false;
            if (_.isArray(_devices) && !_.isEqual(_devices, selectedEventFilters.devices)) {
                _eventFilters = {
                    ..._eventFilters,
                    devices: _devices
                }
                updated = true;
            }
            if (_.isArray(_modules) && !_.isEqual(_modules, selectedEventFilters.modules)) {
                _eventFilters = {
                    ..._eventFilters,
                    modules: _modules
                }
                updated = true;
            }
            if (_.isArray(_levels) && !_.isEqual(_levels, selectedEventFilters.levels)) {
                _eventFilters = {
                    ..._eventFilters,
                    levels: _levels
                }
                updated = true;
            }
            if (_.isArray(_sources) && !_.isEqual(_sources, selectedEventFilters.sources)) {
                _eventFilters = {
                    ..._eventFilters,
                    sources: _sources
                }
                updated = true;
            }
            if (updated) {
                setSelectedEventFilters(_eventFilters);
                // setPage(1);
            }
        }
    }
    console.log("selectedEventFilters",selectedEventFilters)

    return (
        <div className="new-summary-chart-container charts-container-captive-dashboard" style={{ margin: '15px 25px 10px 25px' }}>
            <Grid container spacing={2} className='new-summary-chart-component'>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Grid className="usage-per-site-pie">
                        <div className="site-filter-container siteCharts__filters alignTopbarItemsCenter">
                            <div className="site-filter-item">
                                <div className="sdwanTopbar hub-topology-sdwan-dropdowns-div">
                            {/* {eventFilters && <EventsFilterMenu
                                devices={eventFilters?.devices}
                                modules={eventFilters?.modules.map(value => EVENT_FILTERS.MODULES[value] || value)}
                                levels={eventFilters?.levels.map(value => EVENT_FILTERS.LEVELS[value] || value)}
                                sources={eventFilters?.sources.map(value => EVENT_FILTERS.SOURCES[value] || value)}
                                handleChange={handleEventFiltersChange}
                                defaultSelectionDevices={selectedEventFilters?.devices}
                                defaultSelectionModules={selectedEventFilters?.modules}
                                defaultSelectionLevels={selectedEventFilters?.levels}
                                defaultSelectionSources={selectedEventFilters?.sources}
                            />} */}
                                    {selectedWans && !_.isEmpty(wansList) && <MultipleSelectChip defaultSelection={selectedWans?.map(wan => wan.interface_name)} handleSelection={handleWanSelection} values={wansList?.map(wan => wan.interface_name)} name={'Wans'} sx={{ maxWidth: "250px", width: "250px" }} limitValue={1} />}
                                    {selectedHubs && !_.isEmpty(hubsList) && <MultipleSelectChip defaultSelection={selectedHubs} handleSelection={handleHubSelection} values={hubsList} name={'Hub'} sx={{ maxWidth: "250px", width: "250px" }} limitValue={1} />}
                                    {selectedMetrics && !_.isEmpty(visibleMetrics) && <MultipleSelectChip defaultSelection={selectedMetrics} handleSelection={handleMetricSelection} values={visibleMetrics} name={'Metrics'} sx={{ maxWidth: "250px", width: "250px" }} limitValue={2} />}
                                </div>
                            </div>
                            <div className="site-filter-item jc-end">
                                <Grid className="pieChat-selectTag">
                                    <FormControl variant="standard" className='selectEntry-pie sdwan-select-bin'>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={selectedBin}
                                            onChange={handleBinChange}
                                        >
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 1 && <MenuItem value={'1 minute'}>1m</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 3 && <MenuItem value={'3 minute'}>3m</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 10 && <MenuItem value={'10 minute'}>10m</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 20 && <MenuItem value={'20 minute'}>20m</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 60 && <MenuItem value={'1 hour'}>1h</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 360 && <MenuItem value={'6 hour'}>6h</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 720 && <MenuItem value={'12 hour'}>12h</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 1440 && <MenuItem value={'1 day'}>1d</MenuItem>}
                                            {getMinutes(newSummaryStartDate, newSummaryEndDate) >= 10080 && <MenuItem value={'7 day'}>7d</MenuItem>}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <div className="siteCharts__filters-reset-zoom">
                                    <FormControlLabel
                                        value="Reset Zoom"
                                        control={<IconButton onClick={handleResetZoom}><RestartAltIcon /></IconButton>}
                                        label="Reset Zoom"
                                        labelPlacement="start"
                                    />
                                </div>
                                {(!_.isEmpty(chartOptions?.series) || !_.isEmpty(hubsData)) && <Grid ml={2}>
                                    <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
                                </Grid>}
                            </div>
                        </div>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <div className="siteCharts__charts-container-freeFormTool">
                                <Chart chartOptions={chartOptions} immutable={true} updateArgs={[true, false, true]} enableEventsTable={false} progressBarOptions={progressBarOptions} chartRef={chartRef} hubsRef={hubsRef} selectedMetrics={selectedMetrics} agentSDWAN={true} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (state) => ({
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    userTimezone: state.authReducer.userTimezone,
    getCarrierHubSDWANStatus: state?.authReducer?.getCarrierHubSDWANStatus,
    getCarrierHubSDWANLatency: state?.authReducer?.getCarrierHubSDWANLatency,
    getCarrierHubSDWANDataRates: state?.authReducer?.getCarrierHubSDWANDataRates,
    getCarrierHubSDWANUsage: state?.authReducer?.getCarrierHubSDWANUsage,
    getCarrierHubSDWANBaseRtt: state?.authReducer?.getCarrierHubSDWANBaseRtt,
    getCarrierHubSDWANCurrentRtt: state?.authReducer?.getCarrierHubSDWANCurrentRtt,
    getCarrierHubSDWANPacketDrop: state?.authReducer?.getCarrierHubSDWANPacketDrop,
    getCarrierHubSDWANTunnelMigration: state?.authReducer?.getCarrierHubSDWANTunnelMigration,
    getCarrierHubSDWANPacingRate: state?.authReducer?.getCarrierHubSDWANPacingRate,
    getCarrierHubSDWANBtlbw: state?.authReducer?.getCarrierHubSDWANBtlbw,
    getCarrierHubSDWANBytesInFlight: state?.authReducer?.getCarrierHubSDWANBytesInFlight,
    getCarrierHubSDWANCongestionWindow: state?.authReducer?.getCarrierHubSDWANCongestionWindow,
    getCarrierHubSDWANDroppedDataGrams: state?.authReducer?.getCarrierHubSDWANDroppedDataGrams,
    getCarrierHubSDWANOneWayDelayOwd: state?.authReducer?.getCarrierHubSDWANOneWayDelayOwd,
    getCarrierHubSDWANAckCount: state?.authReducer?.getCarrierHubSDWANAckCount,
    getCarrierHubSDWANPacingLimited: state?.authReducer?.getCarrierHubSDWANPacingLimited,
    getCarrierHubSDWANSentDataGrams: state?.authReducer?.getCarrierHubSDWANSentDataGrams,
    getCarrierHubSDWANBlockCount: state?.authReducer?.getCarrierHubSDWANBlockCount,
    selectedAgent: state?.authReducer?.selectedAgent,
    getCarrierHubSDWANHubs: state?.authReducer?.getCarrierHubSDWANHubs,
    wanDropdown: state.authReducer.getCarrierHubWanDropdown,
    hubsDropdown: state.authReducer.getCarrierHubListDropdown,
    hubEventDetails: state?.authReducer?.hubEventDetails,
    hubEventFilters: state?.authReducer?.hubEventFilters
});

export default withRouter(
    connect(mapStateToProps, { getCarrierHubSDWANStatusChart, getCarrierHubSDWANLatencyChart, getCarrierHubSDWANDataRatesChart, getCarrierHubSDWANUsageChart, getCarrierHubSDWANHubsChart, getCarrierHubAgentDropdownList, getCarrierHubWanDropdownList, getCarrierHubsDropdownList, getHubEvents , getHubEventFilters, getCarrierHubSDWANBaseRttChart, getCarrierHubSDWANCurrentRttChart, getCarrierHubSDWANPacketDropChart,
        getCarrierHubSDWANTunnelMigrationChart, getCarrierHubSDWANPacingRateChart, getCarrierHubSDWANBTLBWChart, getAgentsList, getCarrierHubSDWANBytesInFlightChart, getCarrierHubSDWANCongestionWindowChart, getCarrierHubSDWANDroppedDataGramsChart, getCarrierHubSDWANOneWayDelayOwdChart, getCarrierHubSDWANAckCountChart, getCarrierHubSDWANPacingLimitedChart, getCarrierHubSDWANSentDataGramsChart, getCarrierHubSDWANBlockCountChart }
    )(AgentSDWAN)
);